module.exports = "../study/imgs/maps/Tokyo/S8/Agriculture/RiceQ/Tokyo_RiceQ_HadGEM2_RCP85_Mid.png";